/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../theme/commonStyle";
import { Theme } from "@mui/material";

const faqSectionStyle = {
  section: {
    textAlign: "center",
  },
  content: (theme: Theme) => ({
    height: "100%",
    [theme.breakpoints.up("md")]: {
      margin: "0 20px",
    },
  }),
  title: {
    color: "primary.main",
    padding: "30px",
    minHeight: "72px",
    textDecoration: "none",
  },
  description: {
    padding: "0 30px 30px",
    textAlign: "justify",
  },
  spacerDiv: {
    minHeight: "1.25rem",
  },
  gridItem: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  }),
  scrollToAnchor,
};

export default faqSectionStyle;
